/* eslint-disable */

import React from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import MenuItem from 'material-ui/Menu/MenuItem';

import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from 'react-material-ui-form-validator';
let WAValidator = require('wallet-address-validator');

import { FormControlLabel } from 'material-ui/Form';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';

import Typography from 'material-ui/Typography';

import Button from 'material-ui/Button';
import { withRouter } from 'react-router';
import organizationIcon from '../../assets/images/icons/company.png';
import { translate } from 'react-i18next';

import {
  organizationNameChanged,
  organizationBlockchainAddressChanged,
  organizationContactEmailChanged,
  organizationContactFirstnameChanged,
  organizationContactLastnameChanged,
  organizationContactPhoneNumberChanged,
  organizationTypeChanged,
  organizationMatchingTypeChanged,
  organizationParentOrganizationChanged,
  createOrganizationStart,
  updateOrganizationStart,
  getOrganizationStart,
  getOrganizationFormStart,
  resetCurrentOrganization,
  getOrganizationUserList,
  uploadOrganizationPicture,
  organizationPictureChanged,
  getMatchingTypes,
  getParentOrganizations,
  organizationAutomaticMatchingLiveEnabledChanged,
  organizationAutomaticMatchingOfficialEnabledChanged,
} from '../../actions';
import { constants } from '../../constants';
import { enums } from '../../enums';
import {
  checkUserIsAdmin,
  checkUserIsSuperAdmin,
} from '../../utils/user/checkAdmin/CheckAdmin';

/**
 * Common component import
 */
import LoadingCircle from '../commons/LoadingCircle';
import { Switch } from '@material-ui/core';
import { OrganizationTypes } from '../../enums/OrganizationTypes';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
    margin: 20,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  switch: {
    marginTop: 15,
  },
});

class FormOrganization extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      automaticMatchingLiveEnabled:
        props.currentOrganization.automaticMatchingLiveEnabled,
      automaticMatchingOfficialEnabled:
        props.currentOrganization.automaticMatchingOfficialEnabled,
    };

    this.handleOrganizationAutomaticMatchingLiveEnabledChanged = this.handleOrganizationAutomaticMatchingLiveEnabledChanged.bind(
      this
    );
    this.handleOrganizationAutomaticMatchingOfficialEnabledChanged = this.handleOrganizationAutomaticMatchingOfficialEnabledChanged.bind(
      this
    );
  }

  componentDidMount = async () => {
    const {
      currentOrganization,
      isAuthenticated,
      user,
      matchingTypes,
      parentOrganizations,
    } = this.props;

    if (checkUserIsAdmin(isAuthenticated, user)) {
      const {
        match: { params },
      } = this.props;

      await this.props.getMatchingTypes();
      await this.props.getParentOrganizations();

      // custom rule will have name 'isBlockchainAddress'
      ValidatorForm.addValidationRule('isBlockchainAddress', value => {
        var valid = WAValidator.validate(value, 'ETH');
        return valid;
      });

      ValidatorForm.addValidationRule('isPhoneNumber', phone_number => {
        let phoneno = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;

        let valid = phoneno.test(String(phone_number).toLowerCase());
        return valid;
      });

      ValidatorForm.addValidationRule('isEmail', email => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let valid = re.test(String(email).toLowerCase());
        return valid;
      });

      if (params.organizationId) {
        const organization = await this.props.getOrganizationFormStart(
          params.organizationId
        );
      } else {
        this.props.resetCurrentOrganization();
      }
    } else {
      this.props.history.push('/');
    }
  };

  handleOrganizationBlockchainAddressChange = () => event => {
    this.props.organizationBlockchainAddressChanged(event.target.value);
  };

  handleOrganizationNameChange = () => event => {
    this.props.organizationNameChanged(event.target.value);
  };

  handleOrganizationTypeChange = () => event => {
    this.props.organizationTypeChanged(event.target.value);
  };

  handleOrganizationMatchingTypeChange = () => event => {
    this.props.organizationMatchingTypeChanged(event.target.value);
  };

  handleOrganizationParentOrganizationChange = () => event => {
    this.props.organizationParentOrganizationChanged(event.target.value);
  };

  handleOrganizationContactEmailChange = () => event => {
    this.props.organizationContactEmailChanged(event.target.value);
  };

  handleOrganizationContactFirstnameChange = () => event => {
    this.props.organizationContactFirstnameChanged(event.target.value);
  };

  handleOrganizationContactLastnameChange = () => event => {
    this.props.organizationContactLastnameChanged(event.target.value);
  };

  handleOrganizationAutomaticMatchingLiveEnabledChanged = event => {
    let newState = event.target.checked;

    this.setState({
      automaticMatchingLiveEnabled: newState,
    });

    this.props.organizationAutomaticMatchingLiveEnabledChanged(newState);
  };

  handleOrganizationAutomaticMatchingOfficialEnabledChanged = event => {
    let newState = event.target.checked;

    this.setState({
      automaticMatchingOfficialEnabled: newState,
    });

    this.props.organizationAutomaticMatchingOfficialEnabledChanged(newState);
  };

  handleOrganizationContactPhoneNumberChange = () => event => {
    this.props.organizationContactPhoneNumberChanged(event.target.value);
  };

  handlePictureChange = event => {
    this.props.organizationPictureChanged(event.target.files[0]);
  };

  onDrop = async file => {
    this.props.uploadOrganizationPicture(
      file,
      this.props.currentOrganization.id
    );
  };

  render() {
    const {
      classes,
      currentOrganization,
      matchingTypes,
      parentOrganizations,
      loading,
      loadingForm,
      location,
      localOrganizationPicture,
      isAuthenticated,
      user,
      match: { params },
      t,
      cookies,
    } = this.props;

    let csrfToken = cookies.cookies._csrf;
    if (loadingForm || !currentOrganization) {
      return (
        <div className={classes.root}>
          <LoadingCircle type="empty" classes={classes} />
        </div>
      );
    }
    let updatingOrganization = false;
    if (params.organizationId) {
      updatingOrganization = true;
    }
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    let organizationSelectedPicture = false;

    if (
      currentOrganization &&
      currentOrganization.pictureFileName &&
      !localOrganizationPicture
    ) {
      organizationSelectedPicture =
        process.env.REACT_APP_API_URL +
        '/static/organizations/' +
        currentOrganization.pictureFileName;
    } else if (localOrganizationPicture) {
      organizationSelectedPicture = URL.createObjectURL(
        localOrganizationPicture
      );
    }
    let isSuperAdmin = false;
    let isAdmin = false;
    if (checkUserIsAdmin(isAuthenticated, user)) isAdmin = true;
    if (checkUserIsSuperAdmin(isAuthenticated, user)) isSuperAdmin = true;

    let organizationTypes = constants.OrganizationTypes.filter(type => {
      return type.value !== enums.OrganizationTypes.TEO;
    });

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <img src={organizationIcon} style={{ maxHeight: 20 }} />
                }
                title={t('Organization information')}
              />
              <CardContent>
                <div className={classes.wrapper}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={() => {
                      updatingOrganization
                        ? this.props.updateOrganizationStart(
                            params.organizationId,
                            this.props.currentOrganization,
                            this.props.localOrganizationPicture,
                            this.props.history
                          )
                        : this.props.createOrganizationStart(
                            currentOrganization,
                            this.props.localOrganizationPicture,
                            this.props.history
                          );
                    }}
                    onError={errors => console.log(errors)}
                    className={classNames(classes.margin, classes.textField)}
                  >
                    <Grid item xs={12}>
                      <Row>
                        <Col xs={6}>
                          <Row>
                            <Col>
                              <input
                                type="hidden"
                                name="_csrf"
                                value={{ csrfToken }}
                              />
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t('Name')}
                                onChange={this.handleOrganizationNameChange()}
                                name="name"
                                value={
                                  currentOrganization &&
                                  currentOrganization.name
                                    ? currentOrganization.name
                                    : ''
                                }
                                validators={['required']}
                                errorMessages={['Name is required']}
                              />
                            </Col>
                          </Row>

                          {isSuperAdmin && (
                            <Row>
                              <Col>
                                <SelectValidator
                                  style={{ width: 300 }}
                                  id="select-type"
                                  label={t('Type')}
                                  className={classes.textField}
                                  value={
                                    currentOrganization &&
                                    currentOrganization.type
                                      ? currentOrganization.type
                                      : enums.OrganizationTypes.CUSTOMER
                                  }
                                  validators={['required']}
                                  errorMessages={['Type is required']}
                                  onChange={this.handleOrganizationTypeChange()}
                                  SelectProps={{
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                  margin="normal"
                                >
                                  {organizationTypes.map(option => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </SelectValidator>
                              </Col>
                            </Row>
                          )}

                          {isSuperAdmin &&
                            currentOrganization &&
                            currentOrganization.type &&
                            currentOrganization.type ===
                              enums.OrganizationTypes.CUSTOMER && (
                              <Row>
                                <Col>
                                  <SelectValidator
                                    style={{ width: 300, marginTop: 20 }}
                                    label={t('Parent organization')}
                                    onChange={this.handleOrganizationParentOrganizationChange()}
                                    name="type"
                                    value={
                                      currentOrganization &&
                                      currentOrganization.parentOrganization &&
                                      currentOrganization.parentOrganization._id
                                        ? currentOrganization.parentOrganization
                                            ._id
                                        : ''
                                    }
                                    validators={['required']}
                                    errorMessages={[
                                      'Parent Organization is required',
                                    ]}
                                  >
                                    {parentOrganizations.map(
                                      parentOrganization => (
                                        <MenuItem
                                          key={parentOrganization._id}
                                          value={parentOrganization._id}
                                        >
                                          {parentOrganization.name}
                                        </MenuItem>
                                      )
                                    )}
                                  </SelectValidator>
                                </Col>
                              </Row>
                            )}

                          {isSuperAdmin &&
                            currentOrganization &&
                            currentOrganization.type &&
                            currentOrganization.type ===
                              enums.OrganizationTypes.UTILITY && (
                              <Row>
                                <Col>
                                  <SelectValidator
                                    style={{ width: 300, marginTop: 20 }}
                                    label={t('Matching type')}
                                    onChange={this.handleOrganizationMatchingTypeChange()}
                                    name="type"
                                    value={
                                      currentOrganization &&
                                      currentOrganization.matchingType &&
                                      currentOrganization.matchingType._id
                                        ? currentOrganization.matchingType._id
                                        : ''
                                    }
                                    validators={['required']}
                                    errorMessages={[
                                      'Matching type is required',
                                    ]}
                                  >
                                    {matchingTypes.map(matchingType => (
                                      <MenuItem
                                        key={matchingType._id}
                                        value={matchingType._id}
                                      >
                                        {matchingType.name}
                                      </MenuItem>
                                    ))}
                                  </SelectValidator>
                                </Col>
                              </Row>
                            )}
                          {isSuperAdmin &&
                            currentOrganization &&
                            currentOrganization.type &&
                            currentOrganization.type ===
                              enums.OrganizationTypes.UTILITY && (
                              <Row>
                                <Col>
                                  <TextValidator
                                    style={{ width: 300, marginTop: 20 }}
                                    label={t('Blockchain address')}
                                    onChange={this.handleOrganizationBlockchainAddressChange()}
                                    name="name"
                                    value={
                                      currentOrganization &&
                                      currentOrganization.blockchainAddress
                                        ? currentOrganization.blockchainAddress
                                        : ''
                                    }
                                    validators={[
                                      'isBlockchainAddress',
                                      'required',
                                    ]}
                                    errorMessages={[
                                      'This is not a valid address',
                                      'Address field is required',
                                    ]}
                                  />
                                </Col>
                              </Row>
                            )}
                          <Row style={{ marginTop: 20, marginBottom: 20 }}>
                            <Col>
                              <input
                                accept="image/*"
                                className={classes.input}
                                id="upload-button-file"
                                multiple
                                type="file"
                                style={{ display: 'none' }}
                                onChange={this.handlePictureChange.bind(this)}
                                onDrop={this.onDrop.bind(this)}
                              />
                              <label htmlFor="upload-button-file">
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  component="span"
                                  className={classes.button}
                                  disabled={loading}
                                  style={{
                                    marginTop: 13,
                                    border: '1px solid rgba(248,119,51, 0.5)',
                                    borderRadius: 4,
                                  }}
                                >
                                  Select Picture
                                </Button>
                              </label>
                            </Col>
                            <Col style={{ marginLeft: 10 }}>
                              {organizationSelectedPicture && (
                                <img
                                  src={organizationSelectedPicture}
                                  style={{
                                    height: 60,
                                    width: 60,
                                    borderRadius: '50%',
                                  }}
                                />
                              )}
                              {!organizationSelectedPicture && (
                                <Typography
                                  color="inherit"
                                  variant="caption"
                                  style={{ marginTop: 23 }}
                                >
                                  No picture selected
                                </Typography>
                              )}
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Col>
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t('Contact firstname')}
                                onChange={this.handleOrganizationContactFirstnameChange()}
                                name="firstname"
                                value={
                                  currentOrganization &&
                                  currentOrganization.contactFirstName
                                    ? currentOrganization.contactFirstName
                                    : ''
                                }
                                validators={['required']}
                                errorMessages={[
                                  'Contact firstname is required',
                                ]}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t('Contact lastname')}
                                onChange={this.handleOrganizationContactLastnameChange()}
                                name="lastname"
                                value={
                                  currentOrganization &&
                                  currentOrganization.contactLastName
                                    ? currentOrganization.contactLastName
                                    : ''
                                }
                                validators={['required']}
                                errorMessages={['Contact lastname is required']}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t('Contact phone number')}
                                onChange={this.handleOrganizationContactPhoneNumberChange()}
                                name="phone_number"
                                value={
                                  currentOrganization &&
                                  currentOrganization.contactPhoneNumber
                                    ? currentOrganization.contactPhoneNumber
                                    : ''
                                }
                                validators={['required', 'isPhoneNumber']}
                                errorMessages={[
                                  'Contact phone number is required',
                                  'This is not a valid phone number',
                                ]}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextValidator
                                style={{ width: 300, marginTop: 20 }}
                                label={t('Contact email')}
                                onChange={this.handleOrganizationContactEmailChange()}
                                name="type"
                                value={
                                  currentOrganization &&
                                  currentOrganization.contactEmail
                                    ? currentOrganization.contactEmail
                                    : ''
                                }
                                validators={['required', 'isEmail']}
                                errorMessages={[
                                  'Contact email is required',
                                  'This is not a valid email address',
                                ]}
                              />
                            </Col>
                          </Row>
                          {this.props.currentOrganization &&
                            this.props.currentOrganization.type ===
                              OrganizationTypes.UTILITY && (
                              <Row>
                                <Col>
                                  <div>
                                    <FormControlLabel
                                      className={classes.switch}
                                      control={
                                        <Switch
                                          checked={
                                            this.state
                                              .automaticMatchingLiveEnabled
                                          }
                                          onChange={
                                            this
                                              .handleOrganizationAutomaticMatchingLiveEnabledChanged
                                          }
                                        />
                                      }
                                      label="Automatic live matching"
                                    />
                                  </div>
                                  <div>
                                    <FormControlLabel
                                      className={classes.switch}
                                      control={
                                        <Switch
                                          checked={
                                            this.state
                                              .automaticMatchingOfficialEnabled
                                          }
                                          onChange={
                                            this
                                              .handleOrganizationAutomaticMatchingOfficialEnabledChanged
                                          }
                                        />
                                      }
                                      label="Automatic official matching"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )}
                        </Col>
                      </Row>
                      <Row>
                        <Button
                          type="submit"
                          variant="raised"
                          color="primary"
                          className={buttonClassname}
                          disabled={loading}
                        >
                          {updatingOrganization
                            ? t('Update organization')
                            : t('Create organization')}
                        </Button>
                        {loading && (
                          <LoadingCircle
                            type="buttonProgress"
                            classes={classes}
                          />
                        )}
                      </Row>
                    </Grid>
                  </ValidatorForm>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

FormOrganization.contextTypes = {
  router: PropTypes.object,
};

FormOrganization.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  organizationsReducer,
  router,
  loginReducer,
  matchingTypesReducer,
}) => {
  const {
    currentOrganization,
    loading,
    loadingForm,
    localOrganizationPicture,
    parentOrganizations,
  } = organizationsReducer;
  const { location } = router;
  const { matchingTypes } = matchingTypesReducer;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    currentOrganization,
    loading,
    loadingForm,
    location,
    isAuthenticated,
    username,
    user,
    localOrganizationPicture,
    matchingTypes,
    parentOrganizations,
  };
};

const mapDispatchToProps = {
  organizationNameChanged,
  organizationBlockchainAddressChanged,
  organizationContactEmailChanged,
  organizationContactFirstnameChanged,
  organizationContactLastnameChanged,
  organizationContactPhoneNumberChanged,
  organizationTypeChanged,
  organizationMatchingTypeChanged,
  organizationParentOrganizationChanged,
  createOrganizationStart,
  updateOrganizationStart,
  getOrganizationStart,
  getOrganizationFormStart,
  resetCurrentOrganization,
  getOrganizationUserList,
  uploadOrganizationPicture,
  organizationPictureChanged,
  getMatchingTypes,
  getParentOrganizations,
  organizationAutomaticMatchingLiveEnabledChanged,
  organizationAutomaticMatchingOfficialEnabledChanged,
};

FormOrganization = withStyles(styles, { name: 'FormOrganization' })(
  FormOrganization
);
FormOrganization = translate('translations')(FormOrganization);
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(FormOrganization))
);



// WEBPACK FOOTER //
// ./src/components/Organization/OrganizationForm.js